module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dato-abierto"
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "breadcrumbs"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Datos Abiertos")]), _vm._v("\n      / " + _vm._s(_vm.topic) + "\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.file.title))]), _vm._v(" "), _c('p', {
    staticClass: "area-topic"
  }, [_c('strong', [_vm._v("Tema:")]), _vm._v(" " + _vm._s(_vm.topic))]), _vm._v(" "), (_vm.file.tags) ? _c('p', [_c('strong', [_vm._v("Palabras clave:")]), _vm._v(" " + _vm._s(_vm.file.tags))]) : _vm._e(), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Descripción")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.file.description) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6",
    staticStyle: {
      "padding": "0 !important"
    }
  }, [(_vm.area) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Área:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.area))]), _vm._v(" "), (_vm.area_description) ? _c('span', [_vm._v(" - " + _vm._s(_vm.area_description))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.file.last_update) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Última actualización:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.file.last_update))])]) : _vm._e(), _vm._v(" "), (_vm.file.responsable) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Responsable de los datos:")]), _vm._v(" " + _vm._s(_vm.file.responsable) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.file.email) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Correo electrónico:")]), _vm._v(" " + _vm._s(_vm.file.email) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-6",
    staticStyle: {
      "padding": "0 !important"
    }
  }, [(_vm.file.frequency) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Frecuencia de la actualización:")]), _vm._v(" " + _vm._s(_vm.file.frequency) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.file.position) ? _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Cargo:")]), _vm._v(" " + _vm._s(_vm.file.position) + "\n            ")]) : _vm._e()])])])]), _vm._v(" "), (_vm.canShowRecentFile()) ? _c('div', {
    staticClass: "files"
  }, [_c('h4', [_vm._v("Datos y Recursos")]), _vm._v(" "), _c('div', {
    staticClass: "table table-condensed table-striped table-responsive"
  }, [_c('table', {
    staticClass: "table open-files"
  }, [_c('tbody', _vm._l((_vm.file.current_files), function(da_file) {
    return _c('tr', {
      staticClass: "file-details"
    }, [_vm._m(0, true), _vm._v(" "), _c('td', {
      staticClass: "title"
    }, [(_vm.canShowFileDescription()) ? _c('span', [_vm._v(_vm._s(da_file.description))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "download"
    }, [(_vm.canShowDetailsLink(da_file.external_link)) ? _c('a', {
      staticClass: "button pink-dark rounded icon-left small",
      attrs: {
        "href": da_file.external_link,
        "target": "_blank"
      }
    }, [_vm._m(1, true)]) : _vm._e(), _vm._v(" "), (_vm.canShowDetailsLink(da_file.external_link)) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.canShowDetailsLink(da_file.external_link)) ? _c('br') : _vm._e(), _vm._v(" "), (da_file.url) ? _c('a', {
      staticClass: "button pink-dark rounded icon-left small",
      attrs: {
        "href": da_file.url,
        "target": "_blank"
      }
    }, [_vm._m(2, true)]) : _vm._e()])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.canShowHistoryFile()) ? _c('div', {
    staticClass: "files"
  }, [_c('h4', [_vm._v("Archivos Históricos")]), _vm._v(" "), _c('div', {
    staticClass: "table table-condensed table-striped table-responsive"
  }, [_c('table', {
    staticClass: "table open-files"
  }, [_c('tbody', _vm._l((_vm.file.historical_files), function(da_file) {
    return _c('tr', {
      staticClass: "file-details"
    }, [_vm._m(3, true), _vm._v(" "), _c('td', {
      staticClass: "title"
    }, [(_vm.canShowFileDescription()) ? _c('span', [_c('br'), _vm._v(_vm._s(da_file.description))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "download"
    }, [(_vm.canShowDetailsLink(da_file.external_link)) ? _c('a', {
      staticClass: "button pink-dark rounded icon-left small",
      attrs: {
        "href": da_file.external_link,
        "target": "_blank"
      }
    }, [_vm._m(4, true)]) : _vm._e(), _vm._v(" "), (_vm.canShowDetailsLink(da_file.external_link)) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.canShowDetailsLink(da_file.external_link)) ? _c('br') : _vm._e(), _vm._v(" "), (da_file.url) ? _c('a', {
      staticClass: "button pink-dark rounded icon-left small",
      attrs: {
        "href": da_file.url,
        "target": "_blank"
      }
    }, [_vm._m(5, true)]) : _vm._e()])])
  }))])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "icon"
  }, [_c('span', {}, [_c('i', {
    staticClass: "fa fa-file fa-4x"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v("Ver Datos")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("Descarga")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "icon"
  }, [_c('span', {}, [_c('i', {
    staticClass: "fa fa-file fa-4x"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-chart"
  }), _vm._v("Vista Previa")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("Descarga")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fedcc178","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SingleFile.vue
// module id = 62
// module chunks = 1